import { Fade } from "react-awesome-reveal";
import AnalyzedData from "../analyzedData";
import TestFactorsIcon from "../../../../assets/icons/test-factors.png";
import TestTitle from "../../testCommon/TestTitle";
import { typePersianConverter } from "../../../../utils/Functions";

const TestFactors = ({ testResults, testInfo, footerButtons }: any) => {
  function categorizeByUsageType(data: any) {
    return data.reduce((result: any, item: any) => {
      const type = item.component.usage_type;

      if (!result[type]) {
        result[type] = { normal: [], abnormal: [] };
      }

      if (["ln", "n", "hn", "normal"].includes(item.status?.toLowerCase())) {
        result[type].normal.push(item);
      } else {
        result[type].abnormal.push(item);
      }

      return result;
    }, {});
  }

  const categorizedData = categorizeByUsageType(testResults?.results || {});

  return (
    <Fade triggerOnce>
      <div>
        {Object.entries(categorizedData).map(
          ([category, { normal, abnormal }]: any) => (
            <div key={category} className="mb-10">
              <TestTitle
                title={typePersianConverter(category)}
                subtitle={`فاکتورهایی که از ${typePersianConverter(
                  category
                )} شما استخراج شده‌اند به همراه توضیحات و وضعیتشون.`}
                icon={TestFactorsIcon}
              />

              {abnormal.length > 0 && (
                <AnalyzedData testResults={abnormal} testInfo={testInfo} />
              )}

              {normal.length > 0 && (
                <AnalyzedData testResults={normal} testInfo={testInfo} />
              )}
            </div>
          )
        )}
      </div>
      {footerButtons}
    </Fade>
  );
};

export default TestFactors;
